import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { PageHeader } from "../components/TaskTable";
import { Button } from "../components/ui/button";
import { Switch } from "../components/ui/switch";
import { toast } from "sonner";
import { fmtDate } from "../lib/ui";
import { Bell, CheckCheck, MessageCircle } from "lucide-react";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const [waOn, setWaOn] = useState(true);
  const nav = useNavigate();
  const load = () => api.get("/notifications").then((r) => setItems(r.data));
  useEffect(() => {
    load();
    api.get("/connectors/my-whatsapp-pref").then((r) => setWaOn(r.data.whatsapp_notifications)).catch(() => {});
  }, []);

  const toggleWa = async (v) => {
    setWaOn(v);
    try { await api.put("/connectors/my-whatsapp-pref", { whatsapp_notifications: v }); toast.success(v ? "WhatsApp alerts on" : "WhatsApp alerts off"); }
    catch { setWaOn(!v); toast.error("Save failed"); }
  };

  const open = async (n) => {
    if (n.read === false) await api.post(`/notifications/${n.id}/read`);
    if (n.link_entity === "task" && n.link_id) nav(`/tasks?open=${n.link_id}`);
    else if (n.link_entity === "workspace" && n.link_id) {
      const [wsid, thread] = String(n.link_id).split("#");
      nav(`/workspaces/${wsid}${thread ? `?thread=${thread}` : ""}`);
    }
    else load();
  };
  const readAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div className="p-6 max-w-3xl">
      <PageHeader title="Notifications">
        <Button variant="outline" size="sm" onClick={readAll} data-testid="mark-all-read"><CheckCheck size={14} className="mr-1" /> Mark all read</Button>
      </PageHeader>
      <div className="flex items-center justify-between bg-white border rounded-xl p-4" data-testid="wa-alert-pref">
        <div className="flex items-center gap-3">
          <MessageCircle size={16} className="text-green-600 shrink-0" />
          <div>
            <div className="text-sm font-medium text-slate-800">WhatsApp alerts</div>
            <div className="text-xs text-slate-500">Send me a WhatsApp when a task I own turns Critical or gets Blocked (uses the mobile number on my profile)</div>
          </div>
        </div>
        <Switch data-testid="wa-alert-toggle" checked={waOn} onCheckedChange={toggleWa} />
      </div>
      <div className="space-y-2">
        {items.length === 0 && <div className="text-center py-12 text-slate-400 text-sm">No notifications.</div>}
        {items.map((n) => (
          <button key={n.id} onClick={() => open(n)} data-testid={`notification-${n.id}`}
            className={`w-full text-left rounded-lg p-4 flex items-start gap-3 border ${n.read ? "bg-white" : "bg-blue-50/60 border-blue-200"}`}>
            <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center shrink-0"><Bell size={15} className="text-blue-600" /></div>
            <div className="flex-1">
              <div className="text-sm font-medium text-slate-800">{n.title}</div>
              <div className="text-sm text-slate-600">{n.message}</div>
              <div className="text-xs text-slate-400 mt-0.5">{fmtDate(n.created_at)}</div>
            </div>
            {!n.read && <span className="h-2 w-2 bg-blue-600 rounded-full mt-2" />}
          </button>
        ))}
      </div>
    </div>
  );
}
